/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import DeleteModal from '~/components/DeleteModal';
import { handleDeleteModulo } from '../../ModulosServices';
import { Container } from './styles';

function UpdateCard({
  setForm,
  form,
  moduloData,
  loading,
  handleUpdate,
  setLoading,
}) {
  const history = useHistory();
  const { nome, classeCss, cor } = moduloData;
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const handleDelete = async () => {
    setLoading(true);
    await handleDeleteModulo();
    history.push('/modulo/list');
    setLoading(false);
  };
  return (
    <Container>
      <h1>Atualizar dados do módulo: {nome}</h1>
      <Form style={{ width: '100%' }} onSubmit={handleUpdate}>
        <FormGroup>
          <Label for="name">Nome </Label>
          <Input
            type="text"
            name="name"
            id="name"
            placeholder="Nome do módulo"
            onChange={(e) => {
              setForm({ ...form, nome: e.target.value });
            }}
            defaultValue={nome}
            required
          />
        </FormGroup>
        <FormGroup tag="fieldset">
          <Label>Situação cadastral</Label>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => {
                  setForm({ ...form, situacaoCadastral: 1 });
                }}
                defaultChecked={moduloData.idSituacaoCadastral === 1}
              />{' '}
              Ativo
            </Label>
          </FormGroup>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="radio1"
                onChange={() => {
                  setForm({ ...form, situacaoCadastral: 2 });
                }}
                defaultChecked={moduloData.idSituacaoCadastral !== 1}
              />{' '}
              Inativo
            </Label>
          </FormGroup>
        </FormGroup>

        <FormGroup>
          <Label for="name">Cor </Label>
          <Input
            type="color"
            name="cor"
            id="cor"
            defaultValue={cor}
            onChange={(e) => {
              setForm({ ...form, cor: e.target.value });
            }}
          />
        </FormGroup>
        <FormGroup>
          <Label for="name">Classe CSS </Label>
          <Input
            type="text"
            name="classCss"
            id="classeCss"
            placeholder="Nome da classe CSS"
            onChange={(e) => {
              setForm({ ...form, classe: e.target.value });
            }}
            defaultValue={classeCss}
          />
        </FormGroup>
        <FormGroup>
          <Label for="name">Ordem</Label>
          <Input
            type="number"
            name="ordem"
            id="ordem"
            min={0}
            max={1000}
            onChange={(e) => {
              setForm({ ...form, ordem: e.target.value });
            }}
            defaultValue={moduloData.ordem}
          />
        </FormGroup>
        {loading ? (
          <section>
            <Button color="primary" disabled className="btn2">
              <Spinner size="sm" color="#FFF" />
            </Button>
            <Button color="danger" disabled className="btn1">
              <Spinner size="sm" color="#FFF" />
            </Button>
          </section>
        ) : (
          <section>
            <Button color="primary" onClick={handleUpdate} className="btn2">
              Atualizar
            </Button>
            <Button
              outline
              color="danger"
              onClick={() => {
                toggle();
              }}
              className="btn1"
            >
              Excluir
            </Button>
          </section>
        )}
      </Form>
      <DeleteModal
        toggle={toggle}
        modal={modal}
        handleDelete={handleDelete}
        id={moduloData.id}
        loading={loading}
      />
    </Container>
  );
}

export default UpdateCard;
